// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'thumbs-down-solid';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M4.308 1.996H1.112v9.588h3.196z' />
    <path
      fill='currentColor'
      d='M4.308 10.36c.68.136 1.292.408 1.836.952 1.088 1.02 1.768 2.244 1.768 3.944 0 2.38 3.128 1.292 3.128-.884v-2.788c0-.816.612-1.428 1.428-1.428h3.536c1.768 0 .884-5.44-.884-7.752-.816-1.02-1.7-.952-2.924-.884-4.352.272-4.624 1.564-7.82 1.564z'
    />
  </g>
);

export const viewBox = '0 0 18 18';
